module.exports = __webpack_public_path__ + "static/media/whatsapp.29cfd180.png";